import { createAsyncThunk, Dispatch } from "@reduxjs/toolkit";
import { EventAccommodationReservationService } from "Bands/services/EventAccommodationReservationService";
import {
  BAND_ACTIONS,
  IAccommodationReservationParams,
  IAccommodationSingleReservationParams,
} from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";

export const createAccommodationReservation = createAsyncThunk(
  BAND_ACTIONS.createEventAccommodationReservation,
  async (data: IAccommodationReservationParams, { rejectWithValue }) => {
    try {
      await EventAccommodationReservationService.createAccommodationReservation(
        data
      );

      return;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteAccommodationReservation = createAsyncThunk(
  BAND_ACTIONS.deleteAccommodationReservation,
  async (
    { id, blockId }: { id: string; blockId: string },
    { rejectWithValue, dispatch }
  ) => {
    try {
      await EventAccommodationReservationService.deleteAccommodationReservation(
        id
      );

      dispatchGetEventAccommodationReservations({
        dispatch,
        blockId,
      });

      return {
        path: API_ENDPOINTS.EVENT_ACCOMMODATION_RESERVATION(id),
        dataKey: IDataKeys.eventAccommodationReservation,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editEventAccommodationReservation = createAsyncThunk(
  BAND_ACTIONS.editAccommodationReservation,
  async (
    props: { id: string; data: IAccommodationSingleReservationParams },
    { rejectWithValue }
  ) => {
    try {
      const data =
        await EventAccommodationReservationService.editAccommodationReservation(
          props
        );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const dispatchGetEventAccommodationReservations = ({
  dispatch,
  blockId,
  page = 1,
  itemsPerPage = 15,
  isRecursive = false,
}: {
  dispatch: Dispatch<any>;
  blockId?: string;
  page?: number;
  itemsPerPage?: number;
  isRecursive?: boolean;
}) => {
  dispatch(
    getEventAccommodationReservations({
      blockId,
      page,
      paginationKey: blockId
        ? API_ENDPOINTS.EVENT_ACCOMMODATION_BLOCK(blockId)
        : API_ENDPOINTS.EVENT_ACCOMMODATION_BLOCKS,
      itemsPerPage,
      isRecursive,
    })
  );
};

export const getEventAccommodationReservations = createAsyncThunk(
  BAND_ACTIONS.getEventAccommodationReservations,
  async (
    {
      blockId,
      page,
      itemsPerPage,
      isRecursive,
    }: {
      blockId?: string;
      page: number;
      paginationKey: string;
      itemsPerPage: number;
      isRecursive?: boolean;
    },
    { rejectWithValue }
  ) => {
    try {
      const data =
        await EventAccommodationReservationService.getEventAccommodationReservations(
          {
            accommodation: blockId
              ? API_ENDPOINTS.EVENT_ACCOMMODATION_BLOCK(blockId)
              : undefined,
            page,
            itemsPerPage,
          },
          isRecursive
        );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
